import { render } from "./SvgEditGroup.vue?vue&type=template&id=64a1aaea&ts=true"
import script from "./SvgEditGroup.vue?vue&type=script&lang=ts"
export * from "./SvgEditGroup.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\ga38som\\IdeaProjects\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__